<template>

  <v-select
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
export default {
  name: 'SelectCurrency',
  props: [
    'value',
    'placeholder'
  ],
  data () {
    return {
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    options () {
      return this.resources.currency.map((val) => {
        return {
          label: `${val.name} (${val.key})`,
          value: val.key
        }
      })
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.value
      })
    }
  },
  created () {
  },
  methods: {
    change (val) {
      const value = val ? val.value : val

      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectCurrency.vue